import { ProfileChangeRequestForm } from "../components/profile-change-request-form";
import { CreateChangeRequestDtoTypeEnum } from "../../../../api";

export function EditBuyerProfileRequestPage() {
  return (
    <ProfileChangeRequestForm
      type={CreateChangeRequestDtoTypeEnum.BuyerProfileUpdate}
    />
  );
}
